import createProps from '@kissui/helpers/src/props.helpers'

class Level extends HTMLElement {
    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
    }

    render() {
        const { value, a11y_level_of = 'of', max = '5' } = this.props

        this.innerHTML = `
            <p class="sr-only">${value} ${a11y_level_of} ${max}</p>
            <div>${this.renderLevels(value, max)}</div>
            `
    }

    renderLevels(value, max) {
        let l = ''
        for (let i = 1; i <= max; i++) {
            l = l + this.renderLevel(i, value)
        }
        return l
    }

    renderLevel(i, value) {
        return `<span class="${i <= value ? 'selected' : ''}"></span>`
    }
}

customElements.get('nb-level') || customElements.define('nb-level', Level)
export default Level
